import type { EventDescription } from '~/composables/types/event'
import { useSimilarEvents } from '~/composables/search/useSimilarEvents'

export const SIMILAR_EVENTS_INTRO_COUNT = 6
export const SIMILAR_EVENTS_MAX_COUNT = 8

export const useEventSimilarEvents = () => {
  const eventData = inject<EventDescription>('eventData')
  const permalink = eventGetters.getPermalink(eventData)
  // Engine-aware (KFT-4115): KFT API on algolia, Typesense on typesense, and
  // it follows an A/B force after hydration.
  const { data: similarEvents, pending } = useSimilarEvents(permalink)

  const introSimilarEvents = computed(
    () => similarEvents.value?.slice(0, SIMILAR_EVENTS_INTRO_COUNT) ?? []
  )

  const restSimilarEvents = computed(
    () => similarEvents.value?.slice(SIMILAR_EVENTS_INTRO_COUNT) ?? []
  )

  const allSimilarEvents = computed(
    () => similarEvents.value?.slice(0, SIMILAR_EVENTS_MAX_COUNT) ?? []
  )

  return {
    similarEvents,
    introSimilarEvents,
    restSimilarEvents,
    allSimilarEvents,
    pending,
  }
}

export const useSimilarEventsTitle = (isGiftcard: boolean) => {
  const eventData = inject<EventDescription>('eventData')
  const { t } = useI18n()

  return computed(() => {
    if (isGiftcard) {
      return t('product.giftcardSimilarEvents')
    }

    const specialization = eventData?.specialization

    if (specialization) {
      switch (specialization) {
        case 'COURSE':
          return t('product.similarCourseEvents')
        case 'TOUR':
          return t('product.similarTourEvents')
        case 'EXPERIENCE':
          return t('product.similarExperienceEvents')
        default:
          return t('product.similarEvents')
      }
    }

    return t('product.similarEvents')
  })
}
